module.exports = __webpack_public_path__ + "static/media/circlechevrot-left.acf8c382.svg";